import { Chip } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const StatusPill = ({status, uppercase = false}) => {
    const STATUS_BGS = {
        pending: '#f3c02d',
        confirmed: '#71cb49',
        cancelled: 'red',
        accepted: '#794318',
        sample_collected: '#80CBC4',
        sample_submitted: '#EB5B00',
    };
    const statusText = status.toLowerCase();
    const pillStyles = {
        textTransform:  uppercase ? 'uppercase' : 'capitalize',
        fontWeight: 'bold',
        color: '#FFF'
    };
    return (
        <Chip label={statusText.replace(/_/g, ' ')} style={{ ...pillStyles, backgroundColor: STATUS_BGS[statusText]}} />
    );
};

export default StatusPill;
StatusPill.propTypes = {
    status: PropTypes.string.isRequired,
    uppercase: PropTypes.bool
};